<template>
    <div>
        <join-header :actIndex="actIndex" :imgList="imgList" :topStyle="topStyle" :showback="showback" :logo="logo"></join-header>
        <job-detail :jobInfo="jobInfo" :prevJob="prev" :nextJob="next"></job-detail>
        <join-footer :bottom="bottom" :bottomInfo="contactInfo"></join-footer>
    </div>
</template>

<script>
import JoinHeader from '@/components/mobile/Header'
import JobDetail from '@/components/mobile/JobDetail'
import JoinFooter from '@/components/mobile/Footer'
export default {
    name: 'Job',
    data () {
        return {
            topStyle: "padding-bottom: 20%",
            actIndex: 5,
            imgList: [],
            showback: true,
            bottom: {},
            logo: '',
            contactInfo: {},
            jobInfo: {},
            prev: {},
            next: {},
            jobId: -1
        }
    },
    components: {
        JoinHeader,
        JobDetail,
        JoinFooter,
    },
    mounted () {
    },
    created () {
        this.jobId = this.$route.params.id
        this.getPageData()
    },
    watch: {
        $route () {
            this.jobId = this.$route.params.id
            if(!this.jobId) return
            this.getPageData()
        }
    },
    methods: {
        getPageData () {
            this.$http.get('home/index/m_getjob',{id:this.jobId}, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.contactInfo = res.data.contact[0]
                this.jobInfo = res.data.jobinfo
                this.prev = res.data.prev
                this.next = res.data.next
                this.$nextTick(()=>{
                })
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/Job.vue